import { useCallback, useRef, useState } from "react";

import { useEventListener } from "./useEventListener";

export const useDropdown = () => {
  const elementRef = useRef(null);
  const triggerRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  const maybeCollapse = useCallback(({ target }) => {
    const isOutsideElement =
      !elementRef.current || !elementRef.current.contains(target);
    const isOutsideTrigger =
      !triggerRef.current || !triggerRef.current.contains(target);

    if (isOutsideElement && isOutsideTrigger) {
      setExpanded(false);
    }
  }, []);

  useEventListener(globalThis.document, "mousedown", maybeCollapse);

  return {
    elementRef,
    expanded,
    setExpanded,
    triggerRef,
  };
};
